<template>
  <div class="suspicious-ip">
    <div class="summary-row">
      <div class="summary-card total">
        <div class="summary-icon"><i class="el-icon-warning"></i></div>
        <div class="summary-info">
          <div class="summary-value">{{ summary.total_suspicious || 0 }}</div>
          <div class="summary-label">可疑IP总数</div>
        </div>
      </div>
      <div class="summary-card high">
        <div class="summary-icon"><i class="el-icon-error"></i></div>
        <div class="summary-info">
          <div class="summary-value">{{ summary.high_risk || 0 }}</div>
          <div class="summary-label">高风险</div>
        </div>
      </div>
      <div class="summary-card medium">
        <div class="summary-icon"><i class="el-icon-warning-outline"></i></div>
        <div class="summary-info">
          <div class="summary-value">{{ summary.medium_risk || 0 }}</div>
          <div class="summary-label">中风险</div>
        </div>
      </div>
    </div>

    <div class="table-card">
      <div class="table-header">
        <el-select v-model="hours" placeholder="时间范围" size="small" style="width:130px" @change="loadData">
          <el-option label="近1小时" :value="1" />
          <el-option label="近6小时" :value="6" />
          <el-option label="近12小时" :value="12" />
          <el-option label="近24小时" :value="24" />
          <el-option label="近3天" :value="72" />
          <el-option label="近7天" :value="168" />
        </el-select>
        <el-select v-model="websiteId" placeholder="全部网站" clearable size="small" style="width:180px;margin-left:10px" @change="loadData">
          <el-option label="全部网站" :value="0" />
          <el-option v-for="w in websites" :key="w.id" :label="w.name" :value="w.id" />
        </el-select>
        <el-button type="primary" size="small" style="margin-left:10px" @click="loadData">刷新</el-button>
        <el-button type="warning" size="small" style="margin-left:10px" :loading="scanning" @click="scanAll"><i class="el-icon-search" v-if="!scanning"></i> {{ scanning ? '检测中...' : '检测扫描' }}</el-button>
        <el-button size="small" style="margin-left:10px" @click="openConfig" v-if="isSuper"><i class="el-icon-setting"></i> 检测设置</el-button>
        <span class="table-sub" style="margin-left:auto">{{ scanLabel }} · 共 {{ list.length }} 条</span>
      </div>
      <div class="table-body" v-loading="scanning" element-loading-text="正在扫描全部访问记录..." element-loading-background="rgba(255,255,255,0.85)">
      <el-table :data="list" stripe style="width:100%" size="small" @expand-change="onExpand">
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <div class="expand-detail" v-loading="detailLoading[row.ip]">
              <el-table :data="detailMap[row.ip] || []" size="mini" border style="width:100%">
                <el-table-column label="时间" width="160">
                  <template slot-scope="{ row: r }">{{ formatTime(r.created_at) }}</template>
                </el-table-column>
                <el-table-column label="访问页面" show-overflow-tooltip>
                  <template slot-scope="{ row: r }">{{ r.page_url }}</template>
                </el-table-column>
                <el-table-column label="来源" width="120" show-overflow-tooltip>
                  <template slot-scope="{ row: r }">{{ r.referer_domain || '直接访问' }}</template>
                </el-table-column>
                <el-table-column label="UA" width="200" show-overflow-tooltip>
                  <template slot-scope="{ row: r }">{{ r.user_agent }}</template>
                </el-table-column>
                <el-table-column label="设备" width="90">
                  <template slot-scope="{ row: r }">{{ r.device }}</template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="风险" width="80" align="center">
          <template slot-scope="{ row }">
            <span class="risk-badge" :class="'risk-' + row.risk_level">{{ row.risk_level === 2 ? '高' : '中' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="IP地址" width="160">
          <template slot-scope="{ row }">
            <span class="ip-text">{{ row.ip }}</span>
            <el-tag v-if="blockedIps.has(row.ip)" size="mini" type="danger" effect="dark" style="margin-left:4px">已禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="归属地" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.ip_location || '未知' }}</template>
        </el-table-column>
        <el-table-column label="访问次数" width="90" align="right" sortable>
          <template slot-scope="{ row }">{{ row.visit_count }}</template>
        </el-table-column>
        <el-table-column label="次/小时" width="90" align="right" sortable>
          <template slot-scope="{ row }">{{ row.visits_per_hour }}</template>
        </el-table-column>
        <el-table-column label="独立页面" width="90" align="right" sortable>
          <template slot-scope="{ row }">{{ row.unique_pages }}</template>
        </el-table-column>
        <el-table-column label="可疑UA" width="80" align="right">
          <template slot-scope="{ row }">{{ row.suspicious_ua_count }}</template>
        </el-table-column>
        <el-table-column label="无来源%" width="85" align="right">
          <template slot-scope="{ row }">{{ row.no_referer_ratio }}%</template>
        </el-table-column>
        <el-table-column label="首次访问" width="150">
          <template slot-scope="{ row }">{{ formatTime(row.first_visit) }}</template>
        </el-table-column>
        <el-table-column label="最后访问" width="150">
          <template slot-scope="{ row }">{{ formatTime(row.last_visit) }}</template>
        </el-table-column>
        <el-table-column label="告警原因" min-width="200">
          <template slot-scope="{ row }">
            <div class="reasons">
              <el-tag v-for="(reason, i) in row.reasons" :key="i" size="mini" :type="row.risk_level >= 2 ? 'danger' : 'warning'" style="margin:2px 4px 2px 0">{{ reason }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="isSuper" label="操作" width="90" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-if="!blockedIps.has(row.ip)" type="text" size="mini" style="color:#c76b6b" @click="openBlockDialog(row.ip)">禁用</el-button>
            <el-button v-else type="text" size="mini" style="color:#6b9e72" @click="unblockIp(row.ip)">解禁</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="list.length === 0" class="empty-state">
        <i class="el-icon-success"></i>
        <p>当前时间范围内未检测到可疑IP</p>
      </div>
      </div>
    </div>

    <el-dialog title="可疑IP检测设置" :visible.sync="configDialog" width="580px" append-to-body>
      <el-form :model="configForm" label-width="180px" size="small" v-loading="configLoading">
        <el-divider content-position="left">高频访问检测</el-divider>
        <el-form-item label="高危阈值 (次/小时)">
          <el-input-number v-model="configForm.high_freq_critical" :min="1" :max="9999" controls-position="right" />
          <span class="cfg-hint">≥此值判定为高危</span>
        </el-form-item>
        <el-form-item label="高风险阈值 (次/小时)">
          <el-input-number v-model="configForm.high_freq_high" :min="1" :max="9999" controls-position="right" />
          <span class="cfg-hint">≥此值判定为高风险</span>
        </el-form-item>
        <el-form-item label="中风险阈值 (次/小时)">
          <el-input-number v-model="configForm.high_freq_medium" :min="1" :max="9999" controls-position="right" />
          <span class="cfg-hint">≥此值判定为中风险</span>
        </el-form-item>

        <el-divider content-position="left">页面扫描检测</el-divider>
        <el-form-item label="高危页面数">
          <el-input-number v-model="configForm.scan_pages_critical" :min="1" :max="9999" controls-position="right" />
          <span class="cfg-hint">≥此值且重复率低判定为高危</span>
        </el-form-item>
        <el-form-item label="重复率阈值">
          <el-input-number v-model="configForm.scan_ratio_threshold" :min="1.0" :max="10.0" :step="0.1" :precision="2" controls-position="right" />
          <span class="cfg-hint">访问次数/页面数 &lt; 此值视为扫描</span>
        </el-form-item>
        <el-form-item label="中风险页面数">
          <el-input-number v-model="configForm.scan_pages_medium" :min="1" :max="9999" controls-position="right" />
          <span class="cfg-hint">≥此值判定为中风险</span>
        </el-form-item>

        <el-divider content-position="left">可疑UA检测</el-divider>
        <el-form-item label="高危UA占比">
          <el-input-number v-model="configForm.suspicious_ua_ratio" :min="0.01" :max="1.0" :step="0.05" :precision="2" controls-position="right" />
          <span class="cfg-hint">可疑UA占比 &gt; 此值判定为高危</span>
        </el-form-item>
        <el-form-item label="中风险UA条数">
          <el-input-number v-model="configForm.suspicious_ua_count" :min="1" :max="9999" controls-position="right" />
          <span class="cfg-hint">≥此值判定为中风险</span>
        </el-form-item>

        <el-divider content-position="left">无来源访问检测</el-divider>
        <el-form-item label="无来源比例">
          <el-input-number v-model="configForm.no_referer_ratio" :min="0.01" :max="1.0" :step="0.05" :precision="2" controls-position="right" />
          <span class="cfg-hint">无referer占比 &gt; 此值触发</span>
        </el-form-item>
        <el-form-item label="最低访问次数">
          <el-input-number v-model="configForm.no_referer_min_visits" :min="1" :max="9999" controls-position="right" />
          <span class="cfg-hint">访问量 ≥ 此值才检测</span>
        </el-form-item>

        <el-divider content-position="left">通用设置</el-divider>
        <el-form-item label="最低纳入检测的访问次数">
          <el-input-number v-model="configForm.min_visit_count" :min="1" :max="9999" controls-position="right" />
          <span class="cfg-hint">低于此值的IP不检测</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="configDialog = false">取消</el-button>
        <el-button type="primary" @click="saveConfig" :loading="configSaving">保存配置</el-button>
      </div>
    </el-dialog>

    <el-dialog title="禁用IP" :visible.sync="blockDialog" width="420px" append-to-body>
      <el-form label-width="80px" size="small">
        <el-form-item label="IP地址">
          <span style="font-family:monospace;font-weight:600">{{ blockForm.ip }}</span>
        </el-form-item>
        <el-form-item label="禁用原因">
          <el-input v-model="blockForm.reason" type="textarea" :rows="3" placeholder="可选，如：高频爬虫/扫描器" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="blockDialog = false">取消</el-button>
        <el-button type="danger" @click="confirmBlock" :loading="blockSaving">确认禁用</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { statsApi, websiteApi } from '../api';
import dayjs from 'dayjs';

export default {
  name: 'SuspiciousIp',
  data() {
    return {
      hours: 24,
      websiteId: 0,
      websites: [],
      list: [],
      summary: {},
      detailMap: {},
      detailLoading: {},
      scanning: false,
      scanMode: 'range',
      blockedIps: new Set(),
      blockDialog: false,
      blockSaving: false,
      blockForm: { ip: '', reason: '' },
      configDialog: false,
      configLoading: false,
      configSaving: false,
      configForm: {
        min_visit_count: 5,
        high_freq_critical: 120,
        high_freq_high: 60,
        high_freq_medium: 30,
        scan_pages_critical: 20,
        scan_ratio_threshold: 1.5,
        scan_pages_medium: 10,
        suspicious_ua_ratio: 0.5,
        suspicious_ua_count: 3,
        no_referer_ratio: 0.8,
        no_referer_min_visits: 20,
      },
    };
  },
  computed: {
    isSuper() {
      const user = JSON.parse(localStorage.getItem('wt_user') || '{}');
      return Number(user.is_super) === 1;
    },
    scanLabel() {
      return this.scanMode === 'all' ? '全部记录' : `近 ${this.hours} 小时`;
    }
  },
  mounted() {
    this.loadWebsites();
    this.loadBlockedIps();
    this.loadData();
  },
  methods: {
    async loadWebsites() {
      try {
        const res = await websiteApi.list({ page: 1, page_size: 100 });
        if (res.code === 0) this.websites = res.data.list;
      } catch (e) { console.error(e); }
    },
    async loadData() {
      this.scanMode = 'range';
      try {
        const res = await statsApi.suspiciousIp({ hours: this.hours, website_id: this.websiteId });
        if (res.code === 0) {
          this.list = res.data.list;
          this.summary = res.data.summary;
          this.detailMap = {};
        }
      } catch (e) { console.error(e); }
    },
    async scanAll() {
      this.scanning = true;
      this.scanMode = 'all';
      try {
        const res = await statsApi.suspiciousIp({ hours: 0, website_id: this.websiteId });
        if (res.code === 0) {
          this.list = res.data.list;
          this.summary = res.data.summary;
          this.detailMap = {};
          if (res.data.list.length > 0) {
            this.$message.success(`扫描完成，发现 ${res.data.list.length} 个可疑IP`);
          } else {
            this.$message.success('扫描完成，未发现可疑IP');
          }
        }
      } catch (e) {
        this.$message.error('扫描失败');
        console.error(e);
      }
      this.scanning = false;
    },
    async onExpand(row, expandedRows) {
      if (expandedRows.length === 0) return;
      if (this.detailMap[row.ip]) return;
      this.$set(this.detailLoading, row.ip, true);
      try {
        const res = await statsApi.suspiciousIpDetail({ ip: row.ip, website_id: this.websiteId, limit: 50 });
        if (res.code === 0) {
          this.$set(this.detailMap, row.ip, res.data.list);
        }
      } catch (e) { console.error(e); }
      this.$set(this.detailLoading, row.ip, false);
    },
    async openConfig() {
      this.configDialog = true;
      this.configLoading = true;
      try {
        const res = await statsApi.getSuspiciousConfig();
        if (res.code === 0) {
          this.configForm = { ...this.configForm, ...res.data };
        }
      } catch (e) { console.error(e); }
      this.configLoading = false;
    },
    async saveConfig() {
      this.configSaving = true;
      try {
        const res = await statsApi.updateSuspiciousConfig(this.configForm);
        if (res.code === 0) {
          this.$message.success('配置已保存');
          this.configDialog = false;
          this.loadData();
        } else {
          this.$message.error(res.msg || '保存失败');
        }
      } catch (e) {
        this.$message.error('保存失败');
      }
      this.configSaving = false;
    },
    async loadBlockedIps() {
      try {
        const res = await statsApi.getBlockedIps();
        if (res.code === 0) {
          this.blockedIps = new Set(res.data || []);
        }
      } catch (e) { console.error(e); }
    },
    openBlockDialog(ip) {
      this.blockForm = { ip, reason: '' };
      this.blockDialog = true;
    },
    async confirmBlock() {
      this.blockSaving = true;
      try {
        const res = await statsApi.addIpBlocklist(this.blockForm);
        if (res.code === 0) {
          this.$message.success(res.msg || '已禁用');
          this.blockedIps.add(this.blockForm.ip);
          this.blockedIps = new Set(this.blockedIps);
          this.blockDialog = false;
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      } catch (e) {
        this.$message.error('操作失败');
      }
      this.blockSaving = false;
    },
    async unblockIp(ip) {
      try {
        await this.$confirm(`确认解禁 IP: ${ip} ?`, '解禁确认', { type: 'warning' });
        const res = await statsApi.removeIpBlocklist({ ip });
        if (res.code === 0) {
          this.$message.success(res.msg || '已解禁');
          this.blockedIps.delete(ip);
          this.blockedIps = new Set(this.blockedIps);
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      } catch (e) {
        if (e !== 'cancel') this.$message.error('操作失败');
      }
    },
    formatTime(t) {
      if (!t) return '-';
      return dayjs(t).format('YYYY-MM-DD HH:mm:ss');
    },
  }
};
</script>

<style scoped>
.suspicious-ip { padding: 0; }
.filter-bar { margin-bottom: 16px; display: flex; align-items: center; }

.summary-row { display: flex; gap: 16px; margin-bottom: 16px; }
.summary-card {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #eef0f3;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  position: relative;
  overflow: hidden;
}
.summary-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0;
  width: 3px; height: 100%;
}
.summary-card.total::before { background: #5b8def; }
.summary-card.high::before { background: #c76b6b; }
.summary-card.medium::before { background: #d4905a; }
.summary-icon {
  width: 40px; height: 40px;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  font-size: 20px;
}
.summary-card.total .summary-icon { background: rgba(91,141,239,0.1); color: #5b8def; }
.summary-card.high .summary-icon { background: rgba(199,107,107,0.1); color: #c76b6b; }
.summary-card.medium .summary-icon { background: rgba(212,144,90,0.1); color: #d4905a; }
.summary-value {
  font-size: 24px; font-weight: 600; color: #1e293b;
  font-family: 'SF Mono', Consolas, monospace;
}
.summary-label { font-size: 12px; color: #64748b; margin-top: 2px; }

.table-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #eef0f3;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  overflow: hidden;
}
.table-header {
  padding: 14px 20px;
  border-bottom: 1px solid #eef0f3;
  display: flex; align-items: center; justify-content: space-between;
}
.table-title { font-size: 14px; font-weight: 600; color: #1e293b; }
.table-sub { font-size: 12px; color: #64748b; }
.table-body { position: relative; min-height: 200px; }

.risk-badge {
  display: inline-flex;
  align-items: center; justify-content: center;
  width: 32px; height: 22px;
  border-radius: 4px;
  font-size: 11px; font-weight: 600;
  color: #fff;
}
.risk-badge.risk-2 { background: #c76b6b; }
.risk-badge.risk-1 { background: #d4905a; }

.ip-text {
  font-family: 'SF Mono', Consolas, monospace;
  font-size: 12px; color: #1e293b; font-weight: 500;
}

.expand-detail { padding: 12px 20px; background: #f8f9fa; }
.reasons { display: flex; flex-wrap: wrap; }

.empty-state {
  text-align: center;
  padding: 60px 0;
  color: #6b9e72;
}
.empty-state i { font-size: 48px; }
.empty-state p { font-size: 14px; color: #64748b; margin-top: 12px; }
.cfg-hint { font-size: 12px; color: #94a3b8; margin-left: 10px; }
</style>
